import raf from 'raf'
import BindsObserveEvent from './BindsObserveEvent'

export default (el = window, observerFn) => {
  const observer = BindsObserveEvent(el, 'resize', () => {
    raf(observerFn)
  }, { passive: true })

  return {
    destroy: observer.destroy
  }
}
